import { render } from "./EditManifest.vue?vue&type=template&id=41447d9d&scoped=true"
import script from "./EditManifest.vue?vue&type=script&lang=js"
export * from "./EditManifest.vue?vue&type=script&lang=js"

import "./EditManifest.vue?vue&type=style&index=0&id=41447d9d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41447d9d"]])

export default __exports__